import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { en_US, NzI18nInterface, NzI18nService, ro_RO } from 'ng-zorro-antd/i18n';
import { LOCALES_PATH, SupportedLocales } from '../constants';
import { LocalesResponse } from '../interfaces';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class LocalesService {
  readonly #apiService = inject(ApiService);
  readonly #translateService = inject(TranslateService);
  readonly #i18n = inject(NzI18nService);

  // Make sources private so it's not accessible from the outside
  readonly #localesSource: WritableSignal<LocalesResponse | undefined> = signal(undefined);
  readonly #currentLocale: WritableSignal<SupportedLocales> = signal(SupportedLocales.RO_RO);

  // Exposed signals (read-only)
  readonly locales = this.#localesSource.asReadonly();
  readonly currentLocale = this.#currentLocale.asReadonly();

  constructor() {}

  getAllLocales(): Promise<LocalesResponse> {
    return this.#apiService.getAll(`${LOCALES_PATH}`) as unknown as Promise<LocalesResponse>;
  }

  setAllLocales(locales: LocalesResponse): void {
    this.#localesSource.set(locales);
  }

  setLocale(locale: SupportedLocales): void {
    this.#translateService.use(locale);
    this.#currentLocale.set(locale);

    let ngZorroLocale: NzI18nInterface = en_US;

    switch (locale) {
      case SupportedLocales.RO_RO:
        ngZorroLocale = ro_RO;
        break;
      case SupportedLocales.EN_US:
        ngZorroLocale = en_US;
        break;
    }

    this.#i18n.setLocale(ngZorroLocale);
  }
}
